var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-wrapper-loading-state" },
    [
      _c(
        "div",
        { staticClass: "listing-wrapper-loading-state__header" },
        [
          _c("CompassSkeleton", {
            staticClass: "listing-wrapper-loading-state__skeleton-title",
            attrs: { size: "x-large" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("TableLoading")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }